import React from 'react';
import { FormattedMessage } from 'react-intl';
import Link from '../Link';
import messages from './messages';

const CookieBanner = () => (
  <div className="cookie-banner" data-id="cookie-banner">
    <span className="nt1 black">
      <FormattedMessage {...messages.cookies} />
      <Link to="https://www.fender.com/pages/terms-of-use" className="ml2 underline blue">
        <FormattedMessage {...messages.learnMore} />
      </Link>
    </span>
    <button
      type="button"
      className="absolute right-0 pa2 pr3 pointer no-underline bg-transparent bn z-1"
      style={{ top: '.3rem', pointerEvents: 'none' }}
    >
      <span className="icon-x black" />
    </button>
  </div>
);

export default CookieBanner;
